module.exports = __webpack_public_path__ + "img/stock0.b5727057.png";